import {CustomerCleanerTypes} from '../ActionTypes/CustomerCleanerTypes';

let initialSate = {
  CustomerCleanerList: [],
  CustomerCleanerPagination: null,
};

const CustomerCleanerReducer = (state = initialSate, action) => {
  switch (action.type) {
    case CustomerCleanerTypes.GET_CUSTOMER_CLEANERS:
      let CustomerCleanerList_Copy = [];
      CustomerCleanerList_Copy = [
        ...state.CustomerCleanerList,
        ...action.payload.data,
      ];
      state = {
        ...state,
        CustomerCleanerPagination: action.payload,
        CustomerCleanerList: CustomerCleanerList_Copy,
      };
      break;

    case CustomerCleanerTypes.CLEAR_CUSTOMER_CLEANERS:
      state = {
        CustomerCleanerList: [],
        CustomerCleanerPagination: null,
      };
      break;
  }
  return state;
};

export default CustomerCleanerReducer;
